import { Component, forwardRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { PrFormService } from '@app/components/pr-form/pr-form.service';
import { PrInputComponent } from '@app/components/pr-form/pr-input/pr-input.component';
import { EaEarningFormBuilder } from './ea-earning-form.builder';

@Component({
    selector: 'ea-earning-form',
    templateUrl: './ea-earning-form.component.html',
    styleUrls: ['./ea-earning-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaEarningFormComponent),
        },
    ],
    standalone: false
})
export class EaEarningFormComponent
  extends EaEarningFormBuilder
  implements OnInit
{
  connaissances = [
    { id: 'netMensuel', label: 'Net mensuel', suffix: '€/mois' },
    { id: 'netAnnuel', label: 'Net annuel', suffix: '€/an' },
    { id: 'brutMensuel', label: 'Brut mensuel', suffix: '€/mois' },
    { id: 'brutAnnuel', label: 'Brut annuel', suffix: '€/an' },
  ];

  @ViewChild('amount') amountField: PrInputComponent;

  constructor(protected formConstructor: PrFormConstructor) {
    super(formConstructor);
  }

  ngOnInit() {}

  amountSuffix() {
    let connaissance = this.form.controls.connaissance.value || 'netMensuel';
    return this.connaissances.find(c => c.id === connaissance).suffix;
  }

  onSubmit() {}
}
